// @ts-nocheck
import * as React from "react";

/* Store Custom Code - Start */
import { IconOffset } from "@toolkit/Framework/Types/Icon";
/* Store Custom Code - End */

const ArrowForward: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="m14.673 18.327-.713-.689 5.157-5.158H3v-1h16.137l-5.152-5.157.688-.689 6.346 6.346-6.346 6.347Z"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

/* Store Custom Code - Start */
export const ArrowForwardOffset: IconOffset = {
    vertical: 24,
    horizontal: 12,
};
/* Store Custom Code - End */

export default React.memo(ArrowForward);
